import { zones } from 'Helpers/dates'
import { STORE_KEY_LIST, storeGet } from 'mailup-react-helpers'
import {
  Divider,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  InputNumber,
  Panel,
  RadioButton,
  Select,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_ITALIC_LIGHT,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

import { OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE } from 'Constants'
import BlackoutHours from 'Pages/Workflow/components/Step4/BlackoutHours'
import {
  disableSendSameHour,
  step4ValidData,
  workflowDetails
} from 'Pages/Workflow/recoil/state/data'
import { step4State } from 'Pages/Workflow/recoil/state/step4'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

export const MIN_INPUT_TIME = -1
export const MAX_INPUT_TIME = 99

export const handleMinutes = (minutes, setTime, prevTime) => {
  const formatTime = () => {
    if (minutes > 60) {
      setTime((prevState) => ({
        ...prevState,
        minutes: minutes % 60,
        hours: prevState.hours === 23 ? 0 : prevState.hours + 1,
        minutesVariant: undefined
      }))
    } else {
      switch (minutes) {
        case null:
          setTime((prevState) => ({
            ...prevState,
            minutes: 0
          }))
          break
        case -1:
          setTime((prevState) => ({
            ...prevState,
            minutes: 55,
            hours: prevState.hours === 0 ? 23 : prevState.hours - 1
          }))
          break
        case 60:
          setTime((prevState) => ({
            ...prevState,
            minutes: 0,
            hours: prevState.hours === 23 ? 0 : prevState.hours + 1
          }))
          break
        default:
          setTime((prevState) => ({
            ...prevState,
            minutes
          }))
          break
      }
    }
  }

  if (prevTime.minutes > 50 && minutes > 59) {
    formatTime()
  } else {
    if (minutes > 59) {
      setTime((prev) => ({
        ...prev,
        minutes,
        minutesVariant: 'danger'
      }))
    } else {
      setTime((prevState) => ({
        ...prevState,
        minutesVariant: undefined
      }))
      formatTime()
    }
  }
}

export const handleHours = (hours, setTime) => {
  if (hours > 24) {
    setTime((prevState) => ({
      ...prevState,
      hours,
      hoursVariant: 'danger'
    }))
  } else {
    setTime((prevState) => ({
      ...prevState,
      hoursVariant: undefined
    }))
    switch (hours) {
      case null:
      case 24:
        setTime((prevState) => ({
          ...prevState,
          hours: 0
        }))
        break
      case -1:
        setTime((prevState) => ({
          ...prevState,
          hours: 23
        }))
        break
      default:
        setTime((prevState) => ({
          ...prevState,
          hours
        }))
        break
    }
  }
}

const SendingTime = () => {
  const intl = useIntl()
  const { TimeZoneCode: listTimeZone } = storeGet(STORE_KEY_LIST)
  const disableHour = useRecoilValue(disableSendSameHour)
  const [{ StartHour, TimeZoneCode }, setWorkflowDetails] =
    useRecoilState(step4State)
  const setValidSendingTime = useSetRecoilState(step4ValidData)
  const { Type } = useRecoilValue(workflowDetails)

  const [typingHour, setTypingHour] = useState(false)
  const [typingMinute, setTypingMinute] = useState(false)

  const [sendingType, setSendingType] = useState(
    StartHour === null ? 'asap' : 'sendAt'
  )
  const [sendTime, setSendTime] = useState({
    hours: StartHour === null ? 0 : StartHour.slice(11, 13),
    minutes: StartHour === null ? 0 : StartHour.slice(14, 16),
    hoursVariant: undefined,
    minutesVariant: undefined
  })

  const onSendingTimeChange = (event) => {
    setSendingType(event.target.value)
  }

  const handleMinutesChange = (value) => {
    handleMinutes(value, setSendTime, sendTime)
  }

  const handleHoursChange = (value) => {
    handleHours(value, setSendTime, sendTime)
  }

  const handleChangeTimeZone = (value) => {
    setWorkflowDetails((prev) => ({
      ...prev,
      TimeZoneCode: value
    }))
  }

  useEffect(() => {
    setWorkflowDetails((prev) => ({
      ...prev,
      StartHour:
        sendingType === 'sendAt'
          ? `2000-01-01T${String(sendTime.hours).padStart(2, '0')}:${String(
              sendTime.minutes
            ).padStart(2, '0')}:00Z`
          : null,
      BlackoutStartHour: sendingType === 'asap' ? prev.BlackoutStartHour : null,
      BlackoutEndHour: sendingType === 'asap' ? prev.BlackoutEndHour : null
    }))
  }, [sendTime, sendingType])

  useEffect(() => {
    if (
      sendTime.hoursVariant === 'danger' ||
      sendTime.minutesVariant === 'danger'
    ) {
      setValidSendingTime((prev) => ({
        ...prev,
        validBlackoutHours: false
      }))
    } else {
      setValidSendingTime((prev) => ({
        ...prev,
        validBlackoutHours: true
      }))
    }
  }, [sendTime.hoursVariant, sendTime.minutesVariant])

  useEffect(() => {
    setSendingType(StartHour === null ? 'asap' : 'sendAt')
  }, [StartHour])

  useEffect(() => {
    if (disableHour) {
      setSendingType('asap')
    }
  }, [disableHour, sendingType])

  return (
    <Panel>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.AutomationWorkflow.SetDateTime' })}
      </Title>
      <SpacingVertical variant={SPACING_24} />
      <Flex flexDirection='column' rowGap='24px'>
        <Flex flexDirection='column'>
          <RadioButton
            disabled={
              Type === OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE
            }
            checked={sendingType === 'asap'}
            value={'asap'}
            onChange={onSendingTimeChange}
            label={intl.formatMessage({
              id: 'Load.AutomationWorkflow.SendEmailsEveryHour'
            })}
          />
          {sendingType === 'asap' && <BlackoutHours />}
        </Flex>
        <Flex alignItems='center' columnGap='8px'>
          <RadioButton
            checked={sendingType === 'sendAt'}
            onChange={onSendingTimeChange}
            value={'sendAt'}
            label={intl.formatMessage({
              id: 'Load.AutomationWorkflow.SendEmailsAt'
            })}
            disabled={disableHour}
          />{' '}
          <FlexItem width='70px'>
            <InputNumber
              value={sendTime.hours}
              onChange={handleHoursChange}
              onFocus={() => setTypingHour(true)}
              onBlur={() => setTypingHour(false)}
              formatter={(value) => {
                if (typingHour) {
                  return value
                } else {
                  return value.toString().padStart(2, '0')
                }
              }}
              min={MIN_INPUT_TIME}
              max={MAX_INPUT_TIME}
              disabled={sendingType === 'asap' || disableHour}
              variant={sendTime.hoursVariant}
              precision={0}
            />
          </FlexItem>
          <FlexItem width='70px'>
            <InputNumber
              value={sendTime.minutes}
              onChange={handleMinutesChange}
              onFocus={() => setTypingMinute(true)}
              onBlur={() => setTypingMinute(false)}
              formatter={(value) => {
                if (typingMinute) {
                  return value
                } else {
                  return value.toString().padStart(2, '0')
                }
              }}
              min={MIN_INPUT_TIME}
              max={MAX_INPUT_TIME}
              step={5}
              disabled={sendingType === 'asap' || disableHour}
              variant={sendTime.minutesVariant}
              precision={0}
            />
          </FlexItem>
          {disableHour && (
            <Text htmlElement='span' variant={TEXT_VARIANT_ITALIC_LIGHT}>
              {intl.formatMessage({
                id: 'Load.AutomationWorkflow.TimeConditionsDisabledTooltip'
              })}
            </Text>
          )}
        </Flex>
        <Divider />
        <Grid cols={12}>
          <GridCell span={2}>
            <Flex height='100%' alignItems='center'>
              <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
                {intl.formatMessage({
                  id: 'Load.MailupCommon.setScheduleLblFuso'
                })}
              </Text>
            </Flex>
          </GridCell>
          <GridCell span={10}>
            <Select
              value={TimeZoneCode || listTimeZone}
              onChange={handleChangeTimeZone}
              searchable
              options={Object.entries(zones).map(([code, label]) => ({
                value: code,
                label: `(${code.replace(/([^.]+)\.\d+$/, '$1')}) ${label}`
              }))}
            />
          </GridCell>
        </Grid>
      </Flex>
    </Panel>
  )
}

export default SendingTime
